import { createElementBlock as o, openBlock as l, createElementVNode as n } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(c, e) {
  return l(), o("svg", t, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.08 4.065c.701-.499 1.767-.69 2.85-.69 2.991 0 6.07 2.166 6.07 5.738 0 1.354-.615 3.066-1.512 4.78a28.6 28.6 0 0 1-2.778 4.264 1 1 0 0 0 1.568 1.242 30.6 30.6 0 0 0 2.981-4.578C19.197 13.031 20 10.965 20 9.113c0-4.954-4.275-7.738-8.07-7.738-1.22 0-2.797.198-4.01 1.06a1 1 0 0 0 1.16 1.63M6.624 6.333a1 1 0 1 0-1.777-.916C4.305 6.47 4 7.707 4 9.113c0 1.097.343 2.307.834 3.494.496 1.201 1.174 2.452 1.913 3.65a49 49 0 0 0 4.427 6.024 1 1 0 0 0 1.51-1.312 47 47 0 0 1-4.234-5.76c-.705-1.144-1.326-2.296-1.768-3.366C6.234 10.76 6 9.83 6 9.113c0-1.11.239-2.03.625-2.78M12 12a2.625 2.625 0 1 0 0-5.25A2.625 2.625 0 0 0 12 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: r };
export {
  d as default,
  r as render
};
//# sourceMappingURL=ic_location-BnAUoC5h.js.map
